import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewRoutingModule } from './view-routing.module';
import { ViewPageComponent } from './pages/view-page/view-page.component';
import { ViewColumnComponent } from './components/view-column/view-column/view-column.component';
import { ViewDrawerComponent } from './components/view-drawer/view-drawer.component';
import { MaterialModule } from '../material.module';
import { ButtonsModule } from '../shared/components/buttons/buttons.module';
import { TreeModule } from '../shared/components/tree/tree.module';
import { NgxsModule } from '@ngxs/store';
import { ViewState } from './state/view.state';
import { ViewToolsComponent } from './components/toolbar/view-tools/view-tools.component';
import { ViewDescriptionComponent } from './components/view-description/view-description.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { EngineModule } from '../engine/engine.module';
import { IconModule } from '../shared/components/icon/icon.module';
import { ViewToolbarComponent } from './components/toolbar/view-toolbar/view-toolbar.component';
import { ViewMediaBarComponent } from './components/toolbar/view-media-bar/view-media-bar.component';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ProgressIndictatorsModule } from '../shared/components/progress-indicators/progress-indicators.module';
import { ViewSearchComponent } from './components/view-search/view-search.component';
import { ViewHelpComponent } from './components/view-help/view-help.component';
import { ViewChaptersComponent } from './components/view-chapters/view-chapters.component';
import { NodeActionsModule } from '../shared/components/node-actions/node-actions.module';
import { ViewNodeDescriptionComponent } from './components/view-node-description/view-node-description.component';
import { ViewLoaderComponent } from './components/view-loader/view-loader.component';
import { ViewScrubberComponent } from './components/toolbar/view-scrubber/view-scrubber.component';
import { ViewLogoComponent } from './components/view-logo/view-logo.component';
import { ViewPanelComponent } from './components/view-panel/view-panel.component';
import { ViewLabelsComponent } from './components/view-labels/view-labels.component';
import { ViewContentModeComponent } from './components/view-content-mode/view-content-mode.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PlayLoaderComponent } from './components/view-loader/play-loader/play-loader.component';
import { ViewColumnContainerComponent } from './components/view-column/view-column-container/view-column-container.component';
import { HandLoaderComponent } from './components/view-loader/hand-loader/hand-loader.component';
import { ButtonLoaderComponent } from './components/view-loader/button-loader/button-loader.component';
import { PillboxModule } from '../shared/components/pillbox/pillbox.module';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { ViewColumnToggleComponent } from './components/view-column-toggle/view-column-toggle.component';
import { ViewPrintComponent } from './components/view-print/view-print.component';
import { PopupModule } from '../shared/features/popup/popup.module';
import { PopupComponent } from '../shared/features/components/popup/popup.component';
import { ViewTitleComponent } from './components/view-title/view-title.component';
import { ViewProgressComponent } from './components/view-progress/view-progress.component';
import { ViewTourComponent } from './components/view-tour/view-tour.component';
import { ViewTourMobileComponent } from './components/view-tour/tours/view-tour-mobile/view-tour-mobile.component';
import { ViewTourSlideComponent } from './components/view-tour/view-tour-slide/view-tour-slide.component';
import { ViewTourPageComponent } from './components/view-tour/view-tour-page/view-tour-page.component';
import { ViewTourDesktopComponent } from './components/view-tour/tours/view-tour-desktop/view-tour-desktop.component';
import { ViewTourPagesComponent } from './components/view-tour/view-tour-pages/view-tour-pages.component';
import { ViewRoundedButtonComponent } from './components/view-rounded-button/view-rounded-button.component';
import { ViewTourTipButtonComponent } from './components/view-tour/view-tour-tip-button/view-tour-tip-button.component';
import { ViewTourSuccessComponent } from './components/view-tour/view-tour-success/view-tour-success.component';
import { ViewShortcutsComponent } from './components/view-shortcuts/view-shortcuts.component';
import { ViewLegendComponent } from './components/view-legend/view-legend/view-legend.component';
import { MarkdownModule } from 'ngx-markdown';
import { ViewUndoComponent } from './components/view-undo/view-undo.component';
import { ViewMenuColumnComponent } from './components/view-menu-column/view-menu-column.component';
import { ViewListContainerComponent } from './components/view-list/view-list-container/view-list-container.component';
import { ViewListItemComponent } from './components/view-list/view-list-item/view-list-item.component';
import { ViewAnnotateComponent } from './components/annotate/view-annotate/view-annotate.component';
import { ViewAnnotateToolsComponent } from './components/annotate/view-annotate-tools/view-annotate-tools.component';
import { ViewAnnotateUndoComponent } from './components/annotate/view-annotate-undo/view-annotate-undo.component';
import { ViewLayersBarComponent } from './components/toolbar/view-layers-bar/view-layers-bar.component';
import { ViewLayersSliderComponent } from './components/view-layers-slider/view-layers-slider.component';
import { StoryModule } from '../story/story.module';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { ViewMenuComponent } from './components/toolbar/view-menu/view-menu.component';
import { NotificationModule } from '../shared/features/notification/notification.module';
import { ErrorComponent } from '../pages/error/error.component';
import { ContentBlocksModule } from '../content-blocks/content-blocks.module';
import { SharedModule } from '../shared/shared.module';
import { ViewAnnotateLabelComponent } from './components/annotate/view-annotate-label/view-annotate-label.component';
import { QuizModule } from '../quiz/quiz.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ViewQuizModule } from './components/quiz/view-quiz.module';
import { ViewOndemandComponent } from './components/view-ondemand/view-ondemand.component';
import { ViewContentWarningComponent } from './components/view-content-warning/view-content-warning.component';
import { ViewIphone12WarningComponent } from './components/view-iphone12-warning/view-iphone12-warning.component';


@NgModule({
  declarations: [
    ButtonLoaderComponent,
    ErrorComponent,
    HandLoaderComponent,
    PlayLoaderComponent,
    ViewAnnotateComponent,
    ViewAnnotateLabelComponent,
    ViewAnnotateToolsComponent,
    ViewAnnotateUndoComponent,
    ViewChaptersComponent,
    ViewColumnComponent,
    ViewColumnContainerComponent,
    ViewColumnContainerComponent,
    ViewColumnToggleComponent,
    ViewContentModeComponent,
    ViewContentWarningComponent,
    ViewDescriptionComponent,
    ViewDrawerComponent,
    ViewHelpComponent,
    ViewIphone12WarningComponent,
    ViewLabelsComponent,
    ViewLayersBarComponent,
    ViewLayersSliderComponent,
    ViewLegendComponent,
    ViewListContainerComponent,
    ViewListItemComponent,
    ViewLoaderComponent,
    ViewLogoComponent,
    ViewMediaBarComponent,
    ViewMenuColumnComponent,
    ViewMenuComponent,
    ViewNodeDescriptionComponent,
    ViewOndemandComponent,
    ViewPageComponent,
    ViewPanelComponent,
    ViewPrintComponent,
    ViewProgressComponent,
    ViewRoundedButtonComponent,
    ViewScrubberComponent,
    ViewSearchComponent,
    ViewShortcutsComponent,
    ViewShortcutsComponent,
    ViewTitleComponent,
    ViewToolbarComponent,
    ViewToolsComponent,
    ViewTourComponent,
    ViewTourDesktopComponent,
    ViewTourMobileComponent,
    ViewTourPageComponent,
    ViewTourPagesComponent,
    ViewTourSlideComponent,
    ViewTourSuccessComponent,
    ViewTourTipButtonComponent,
    ViewUndoComponent,
  ],
  imports: [
    NgxsModule.forFeature([ViewState]),
    MarkdownModule.forChild(),

    // Google Analytics
    NgxGoogleAnalyticsModule,

    CommonModule,
    EngineModule,

    ViewRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,

    ButtonsModule,
    DirectivesModule,
    IconModule,
    PipesModule,
    PillboxModule,
    PopupModule,
    TreeModule,
    ProgressIndictatorsModule,
    NodeActionsModule,
    LazyLoadImageModule,
    BookmarksModule,
    StoryModule,
    ContentBlocksModule,
    SharedModule,

    NotificationModule,
    QuizModule,
    ViewQuizModule
  ],
  exports: [ViewPageComponent],
  entryComponents: [
    ViewChaptersComponent,
    ViewMediaBarComponent,
    PopupComponent
  ]
})
export class ViewModule { }
